import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, combineLatest } from "rxjs";
import { distinctUntilChanged, filter, map, take, tap } from 'rxjs/operators';
import { CmsComponentData, CurrentProductService, IconModule, MediaModule } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ConverterService, I18nModule, PRODUCT_NORMALIZER, Product, User } from '@spartacus/core';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { GenGaListNames } from 'src/app/generac/enums/ga-list-names.enum';
import { GaItem, GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';
import { GenProductService } from 'src/app/generac/services/product.service';
import { CommonModule } from '@angular/common';
import { GenSharedModule } from 'src/app/generac/shared/shared.module';
import { GenAddToCartModule } from '../../cart/product-add-to-cart/product-add-to-cart.module';
import { GenProductWarrantyItemComponent } from './product-warranty-item/product-warranty-item.component';
import { GenInfoMessageComponent } from 'src/app/generac/shared/components/info-message/info-message.component';
import { isEqual } from 'src/app/generac/shared/helpers/is-equal';

@Component({
  selector: 'gen-product-warranties',
  templateUrl: './product-warranties.component.html',
  imports: [
    CommonModule,
    I18nModule,
    GenSharedModule,
    IconModule,
    MediaModule,
    GenInfoMessageComponent,
    GenProductWarrantyItemComponent,
    GenAddToCartModule,
  ],
})
export class GenProductWarrantiesComponent implements OnInit, OnDestroy {
  warranties$: Observable<Product[]>;
  subscription = new Subscription();
  user: User;
  phoneOrEmail: any;
  tooltipMessage: any;
  title$: Observable<string | undefined> | undefined =
    this.component?.data$.pipe(map((data) => data.title));
  warrantiesTooltipMessage: string;
  warrantiesTooltipText: string;
  gaItems: GaItem[] = [];
  gaListName: GenGaListNames = GenGaListNames.WARRANTIES;

  constructor(
    public component: CmsComponentData<any>,
    protected productService: GenProductService,
    protected currentProductService: CurrentProductService,
    protected baseStoreService: GenBaseStoreService,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
    private userAccount: UserAccountFacade,
    private cdr: ChangeDetectorRef,
    private converter: ConverterService,
  ) {
    this.subscribeToUser();
    this.subscribeToContactInfoAndTooltip();
  }

  ngOnInit(): void {
    this.warranties$ = combineLatest([this.currentProductService.getProduct(), this.component?.data$]).pipe(
      distinctUntilChanged(isEqual),
      map(([product, componentData]) => {
        const maximumNumberProducts = Number(componentData.maximumNumberProducts);
        this.warrantiesTooltipText = componentData.warrantyTooltipMessage;
        const warranties: Product[] = product?.warranties.map((product: Product) => {
          return this.converter.convert({
            ...product,
            productCode: product.code,
          }, PRODUCT_NORMALIZER);
        });

        if (warranties.length > 0) {
          this.googleAnalyticsService.sendViewItemListEvent(warranties.slice(0, maximumNumberProducts), this.gaListName);
        }

        return warranties.slice(0, maximumNumberProducts);
      })
    )
  }

  private subscribeToContactInfoAndTooltip(): void {
    this.subscription.add(
      combineLatest([
        this.baseStoreService.getTooltipMessage(),
        this.baseStoreService.getPhoneNumber(),
      ]).subscribe(([messsage, phoneOrEmail]) => {
        this.tooltipMessage = messsage?.message;
        this.phoneOrEmail = phoneOrEmail?.contactInfo;
        this.cdr.markForCheck();
      })
    );
  }

  private subscribeToUser(): void {
    this.subscription.add(
      this.userAccount.get()
        .pipe(
          filter(Boolean),
          tap(user => this.user = user)
        )
        .subscribe()
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
